import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jsmKbAiFirstCreateEmbedRoute: InvariantJiraRoute = {
	name: 'jsm-kb-ai-first-create-embed',
	path: '/jira/servicedesk/create-kb/embed',
	exact: true,
};
